import { AdvertiserForm } from 'components/advertisers'

export const CreateAdvertiser = () => {
  return <AdvertiserForm isNew />
}